import type { ComponentProps } from 'react';

import type { RouteObject } from '@suntex.core/nav';
import { isTeamLeaderOrHigher } from '@suntex.fim/auth/react';
import { RequireAuth } from '@suntex.fim/framework';
import {
  ContentLibraryPage,
  PlayerDashboard,
  PlayerProvider,
} from '@suntex.fim/player';

import { PREVIEW_ROUTE } from '../const';
import { EntityLevelLayout } from '../layouts/EntityLevelLayout';

import { PreviewPathRedirect } from './redirects/PreviewPathRedirect';

export interface CreatePreviewRoutesOptions {
  chrome: ComponentProps<typeof EntityLevelLayout>;
  /** Module routes mounted under `/preview/modules`; passed in because @suntex.fim/modules depends on this package. */
  moduleRoutes: RouteObject[];
}

/**
 * Builds the shared `/preview` route tree: auth-gated to team leaders and
 * above, rendering the player dashboard and modules in preview mode. The
 * chrome and menu follow the login's own entity, not the player menu.
 */
export function createPreviewRoutes({
  chrome,
  moduleRoutes,
}: CreatePreviewRoutesOptions): RouteObject[] {
  return [
    {
      path: PREVIEW_ROUTE,
      element: <RequireAuth requirement={isTeamLeaderOrHigher} />,
      children: [
        {
          element: (
            <PlayerProvider isPreview>
              <EntityLevelLayout {...chrome} />
            </PlayerProvider>
          ),
          children: [
            { index: true, Component: PlayerDashboard },
            { path: 'content-library', Component: ContentLibraryPage },
            { path: 'modules', children: moduleRoutes },
            { path: 'player/*', Component: PreviewPathRedirect },
          ],
        },
      ],
    },
  ];
}
